import { useMemo } from "react";
import { get } from "lodash";
import { useQuery } from "@tanstack/react-query";

import { queryClient } from "App";
import { addResizedColumns } from "./useTableConfig";
import { MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS } from "routes/machine_approval_statuses/MachineApprovalStatusTableV3";
import UserService from "services/User";
import {
  getMachineApprovalStatusTableColumns,
  getMachineApprovalStatusTableFilters,
} from "routes/machine_approval_statuses/MachineApprovalStatusTableColumnsAndFilters";

export const invalidateMachineApprovalStatusTableQuery = async () => {
  await queryClient.invalidateQueries({
    queryKey: [MACHINE_APPROVAL_STATUS_TABLE_CONSTANTS.queryKey],
  });
};

export const useMachineApprovalStatusTable = ({ tableName }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const filters = useMemo(() => {
    return getMachineApprovalStatusTableFilters();
  }, []);

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getMachineApprovalStatusTableColumns();

    const machineApprovalStatusTableSettings = get(
      tableSettings,
      `user_settings.preferences.tables.${tableName}`,
      {}
    );
    const withResizedColumns = addResizedColumns({
      columns: initialColumns,
      resizedColumns: machineApprovalStatusTableSettings?.resized_columns || {},
    });

    return withResizedColumns;
  }, [tableName, tableSettings, isTableSettingsFetched]);

  return { filters, columns };
};
